import { graphql } from 'graphql-setup'

export const SIDEBAR_QUERY = graphql(`
  query Sidebar {
    allIssues(closedAt_Isnull: true, archivedAt_Isnull: true) {
      total
    }
    allFormTemplates(excludeArchived: true, onlyMenuShortcuts: true) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`)
